export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'nb', name: 'Norsk Bokmål' },
  { code: 'nn', name: 'Norsk Nynorsk' },
  { code: 'sv', name: 'Svenska' },
  { code: 'da', name: 'Dansk' },
  { code: 'fi', name: 'Suomi' }
];

export const getLanguageOptions = () => {
  return SUPPORTED_LANGUAGES.map(lang => ({
    label: lang.name,
    value: lang.code
  }));
}; 